export default /* glsl */`
// uniform sampler2D tEquirect; // I don't even know how this was supposed to work, some skybox hijink?

uniform sampler2D map; // this is set by threejs automatically
uniform vec3 offset;

varying vec3 vWorldDirection;
varying vec3 vWorldPosition;

#include <common>
// #include <tonemapping_pars_fragment>
// #include <encodings_pars_fragment>

// this is the way that threejs equidirectional sampling works for UV
vec2 normalUvProjection(vec3 worldDirection){

  vec3 direction = normalize( worldDirection );

	vec2 sampleUV;

	sampleUV.y = asin( clamp( direction.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
  sampleUV.x = atan( direction.z, direction.x ) * RECIPROCAL_PI2 + 0.5;
  
  return sampleUV;
}

vec2 positionalUvProjection(vec3 worldPosition){

  vec3 direction = normalize(worldPosition);
  vec2 longlat = vec2(atan(direction.y, -direction.x), acos(-direction.z)) ;
  vec2 uv = longlat / vec2(2.0 * PI, PI);
  uv.x += 0.5;
  return uv;
}

void main() {

  // vec2 nUvSample = normalUvProjection( vWorldDirection );
  // vec4 normalTexColor = texture2D( map, nUvSample );
  vec3 adjustedPos = vWorldPosition ;
  vec2 pUvSample = positionalUvProjection( adjustedPos + offset );
  // vec2 pUvSample2 = positionalUvProjection( vWorldPosition + offset * 2.0 );

  vec4 posTexColor = texture2D( map, pUvSample );
  // vec4 posTexColor2 = texture2D( map, pUvSample2 );
  // float factor = min(vWorldDirection.y, 1.0);
  // vec4 finalTexColor = mix(posTexColor, posTexColor2, factor);

  gl_FragColor = mapTexelToLinear( posTexColor );
	#include <tonemapping_fragment>
  // gl_FragColor = vec4(0.0, 1.0, 0.0, 1.0);
  // gl_FragColor = posTexColor;

	#include <encodings_fragment>

}
`;